// extracted by mini-css-extract-plugin
module.exports = {"section":"LegalDisclaimer-module--section--1hkzF"};